import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { CommonWordingPipe } from '@platform-frontend/ui-tools';
import { Observable, of } from 'rxjs';
import { PLATFORM_TRANSLOCO_SCOPE } from '../platform-transloco-scope';
import { LegalWording } from './legal-wording';

@Pipe({
  name: 'legalWording'
})
export class LegalWordingPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(value: LegalWording, staticKeys?: Record<LegalWording, string>): Observable<string> {
    return staticKeys
      ? of(staticKeys[value])
      : new CommonWordingPipe<LegalWording>(this.translocoService).transform(value, undefined, PLATFORM_TRANSLOCO_SCOPE, 'legal.');
  }
}
